import { Controller } from "@hotwired/stimulus"
import { introAlreadyPlayed, prefersReducedMotion } from "../helpers/intro_once"

// Plays a CSS entrance animation exactly once per device. The animation class
// lives off the element in the markup and is only added here, so an intro that
// has already played (or a device that prefers reduced motion) renders settled
// with no flash. Same gate as reveal_controller, generalised over a key.
//
// Usage:
//   <img data-controller="intro-once"
//        data-intro-once-key-value="actions-mascots"
//        data-intro-once-animation-class-value="mascot-anim">
export default class extends Controller {
  static values = { key: String, animationClass: String }

  connect() {
    if (!this.keyValue || !this.animationClassValue) return
    if (prefersReducedMotion() || introAlreadyPlayed(this.keyValue)) return

    this.element.classList.add(this.animationClassValue)
  }
}
